import { observable, action, computed, flow } from 'mobx';
import { Toast, Modal } from 'antd-mobile';

import Util from 'utils';
import { rstr2b64 } from 'utils/md5';
import Stores from 'config/Stores';
import Serv from './AgreementsServ';

class AgentRegisterMod {
  /* ---- 请求未回来，所有协议置为必须同意 ---- */
  // 注册须知协议、是否禁用注册协议
  @observable notice = {};

  @observable disableNotice = false;

  // 生命银行协议、是否禁用注册协议
  @observable productAgreement = {};

  @observable disableProductAgreement = false;

  // 代理经销商合同、是否禁用代理经销商合同
  @observable agency = {};

  @observable disableAgency = false;

  // 健康顾问工作室申请人承诺书、是否禁用健康顾问工作室申请人承诺书
  @observable stdPromise = {};

  @observable disableStdPromise = false;

  // 授权经销协议、是否禁用授权经销协议
  @observable grantAgent = {};

  @observable disableGrantAgent = false;

  // 健康顾问工作室培训条例、是否禁用健康顾问工作室培训条例
  @observable stdTrain = {};

  @observable disableStdTrain = false;
  //店铺合同
  @observable contracts = [];

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 获取注册须知协议
   */
  getNoticeAgreement = flow(function* (type = 'registration') {
    try {
      const { data } = yield Serv.getAgreement(type);
      this.notice = data;
      this.disableNotice = data.status == 0;
    } catch (error) {}
  });

  /**
   * 获取生命银行
   */
  getProtocolByItems = flow(function* (code) {
    if (!code) return;
    try {
      const { data } = yield Serv.getAgreement(code);
      this.productAgreement = data;
      this.disableProductAgreement = data.status == 0;
    } catch (error) {}
  });

  /**
   * 获取代理经销商协议
   */
  getAgencyAgreement = flow(function* () {
    try {
      const { data } = yield Serv.getAgreement('agency');
      this.agency = data;
      this.disableAgency = data.status == 0;
    } catch (error) {}
  });

  /**
   * 获取工作室相关协议
   */
  getStudioAgreements = flow(function* (param) {
    const { userInfo } = Stores.AppMod;
    const { belongSystem } = userInfo || {};
    let params = {
      codes: 'Letter,Agreement,Rules',
      belongSystem: belongSystem
    };
    if (param && param.type == 1) {
      params = {
        type: 1,
        belongSystem: belongSystem,
        ...param
      };
    }
    try {
      const { data } = yield Serv.getStoreAgreements(params);
      let list = (data || []).filter((item) => item.status);
      this.contracts = list;
      if (param && param.type == 1) return list;
      // 请求回来，将工作室协议全部置为不需同意，再逐条遍历，重置需同意的协议
      this.disableStdPromise = true;
      this.disableGrantAgent = true;
      this.disableStdTrain = true;
      if (Array.isArray(data)) {
        data.forEach((item) => {
          if (item.code == 'Letter') {
            this.stdPromise = item;
            this.disableStdPromise = item.status == 0;
          } else if (item.code == 'Agreement') {
            this.grantAgent = item;
            this.disableGrantAgent = item.status == 0;
          } else if (item.code == 'Rules') {
            this.stdTrain = item;
            this.disableStdTrain = item.status == 0;
          }
        });
      }
    } catch (error) {}
  });

  /**
   * 根据id查合同
   */
  queryContractById = flow(function* (params) {
    try {
      const { data } = yield Serv.queryContractById(params);
      this.agency = data[0];
      this.disableAgency = data.status == 0;
    } catch (error) {}
  });

  /**
   * 上报内容提醒次数
   */
  reportAgreement = flow(function* () {
    try {
      const { data } = yield Serv.reportAgreement();
    } catch (error) {}
  });

  /**
   * 上报合同确认
   */
  reportAgreementConfirm = flow(function* (params) {
    try {
      const result = yield Serv.reportAgreementConfirm(params);
      return result;
    } catch (error) {}
  });
}
const agentRegisterMod = new AgentRegisterMod();
export default agentRegisterMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Agreements/AgreementsMod.js